export const PRIVACY = 'Я подтверждаю, что ознакомлен и принимаю положения';
export const POLICY = 'Я подтверждаю, что ознакомлен и принимаю';
export const IMG_TEXT = 'Допустимые форматы jpg, png Размер файла не более 500 КБ';
export const EMAIL_TOOLTIP = 'Для смены email обратитесь к администратору';
export const INSTITUTE_TOOLTIP = 'Для добавления нового учреждения обратитесь к администратору';
export const ERROR = 'Неизвестная ошибка';
export const ADMINISTRATION = 'Обратитесь к администратору';
export const EMAIL = 'edu@fond-igra.ru';
export const FAMILY_NAME = 'Фамилия';
export const NAME = 'Имя';
export const SURNAME = 'Отчество';
export const NAME_PLACEHOLDER = 'Введите ваше имя';
export const FAMILY_NAME_PLACEHOLDER = 'Введите вашу фамилию';
export const SURNAME_PLACEHOLDER = 'Введите ваше отчество';
export const REGION = 'Регион';
export const SPECIALIZATION = 'Специализация';
export const SPECIALIZATION_PLACEHOLDER = 'Введите информацию о специализации';
export const INSTITUTION = 'Учреждение';
export const AGREEMENT = 'Пользовательского соглашения';
export const PRIVACY_POLICY = 'Политику конфиденциальности';
export const GAME = 'благотворительного фонда «Игра» и согласен на';
export const PERSONAL_DATA = 'обработку моих персональных данных';
export const SAVE = 'Сохранить';
export const REBOOT = 'Перезагрузить страницу';
export const TITLE = 'Мой профиль';
export const UPLOAD_PHOTO = 'Загрузить фото';
export const EMAIL_LABEL = 'Email';
export const CHOOSE_REGION = 'Выберите регион';
export const CHOOSE_INSTITUTE = 'Выберите учреждение';
export const EXIT = 'Выйти';
export const STAY = 'Остаться';
export const OUT = 'Да, выйти';
